export default __webpack_public_path__ + "static/media/2.b42ed42c.png";